import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import resetError from 'shared/errorHandler/actions/resetError'
import getFlightInfo from './actions/getFlightInfo'
import Briefing from './components/index'

const mapStateToProps = (state) => {
    return ({
        flightInfo: state.briefing.flightInfo.data,
        error: state.error.message,
        username: state.user.username
    })
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
        resetError,
        getFlightInfo
    }, dispatch)
})

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Briefing))



// WEBPACK FOOTER //
// ./src/screens/briefing/index.js